class QueryError extends Error {
  constructor(combinedError) {
    super("Gql query error");
    this.status = 400;
    this.combinedError = combinedError;
  }
}

export default QueryError;
